<app-common-bulk-select-employee-dialog
    #selectEmployees
    headerText="forms.training.assignEmployees"
></app-common-bulk-select-employee-dialog>
<form #form="ngForm">
    <ng-container *ngIf="program">
        <div class="app-grid">
            <mat-form-field>
                <mat-label>{{ 'forms.training.name' | translate }}</mat-label>
                <input
                    type="text"
                    placeholder=""
                    required
                    #name="ngModel"
                    name="name"
                    [(ngModel)]="program.name"
                    matInput
                />
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'training.description' | translate }}</mat-label>
                <ui-rich-text name="description" #message="ngModel" [(ngModel)]="program.description"></ui-rich-text>
            </mat-form-field>
            <div class="attach-file">
                <app-file-drop
                    (filesSelected)="onFileSelected($event)"
                    [inlineView]="true"
                    [allowedTypes]="allowedFileTypes"
                    [allowMultiple]="true"
                    [maxFileSize]="30"
                    [required]="false"
                >
                </app-file-drop>
                <mat-label class="form-label" *ngFor="let file of fileManager.fileModels">
                    <span>{{ file.name }}</span>
                    <img (click)="onFileModelRemoved(file)" appIcon="CrossBlueUiOutline" />
                </mat-label>
                <mat-label class="form-label" *ngFor="let file of fileManager.inputFiles">
                    <span>{{ file.name }}</span>
                    <img (click)="onFileRemoved(file)" appIcon="CrossBlueUiOutline" />
                </mat-label>
            </div>
            <div class="form-block">
                <h4>{{ 'forms.training.selectTrainingDetailsH4' | translate }}</h4>
                <div class="app-grid">
                    <mat-checkbox
                        [(ngModel)]="program.hasExpirationDate"
                        #checkboxControl="ngModel"
                        name="hasExpirationDate"
                        >{{ 'training.expirationDate' | translate }}</mat-checkbox
                    >
                </div>

                <div class="app-grid">
                    <mat-checkbox [(ngModel)]="program.hasInstructor" #checkboxControl="ngModel" name="hasInstructor">{{
                        'training.instructor' | translate
                    }}</mat-checkbox>
                </div>
                <div class="app-grid">
                    <mat-checkbox [(ngModel)]="program.hasHours" #checkboxControl="ngModel" name="hasHours">{{
                        'dateTime.hours' | translate
                    }}</mat-checkbox>
                </div>
                <div class="app-grid">
                    <mat-checkbox [(ngModel)]="program.hasCredits" #checkboxControl="ngModel" name="hasCredits">{{
                        'training.credits' | translate
                    }}</mat-checkbox>
                </div>
                <div class="app-grid">
                    <mat-checkbox [(ngModel)]="program.hasCost" #checkboxControl="ngModel" name="hasCost">{{
                        'training.cost' | translate
                    }}</mat-checkbox>
                </div>
                <div class="app-grid">
                    <mat-checkbox [(ngModel)]="program.hasResult" #checkboxControl="ngModel" name="hasResult">{{
                        'forms.training.resultIePassFail' | translate
                    }}</mat-checkbox>
                </div>
            </div>
            <div class="form-block">
                <mat-checkbox
                    [(ngModel)]="program.isEmployeeSubmittable"
                    #checkboxControl="ngModel"
                    name="isEmployeeSubmittable"
                    >{{ 'forms.training.allowEmployeesToRecord' | translate }}</mat-checkbox
                >
            </div>
            <div class="form-block">
                <h4>{{ 'forms.training.doesThisProgramHaveADueDate' | translate }}</h4>
                <div class="app-grid">
                    <mat-radio-group aria-label="Select an option" name="hasDueDate" [(ngModel)]="hasDueDate">
                        <div>
                            <mat-radio-button [value]="false">{{ 'training.noDueDate' | translate }}</mat-radio-button>
                        </div>
                        <div>
                            <mat-radio-button [value]="true">{{
                                'forms.training.setADueDate' | translate
                            }}</mat-radio-button>
                        </div>
                    </mat-radio-group>
                </div>
                <div *ngIf="hasDueDate">
                    <span class="label input-detail">{{ 'forms.training.due' | translate }}</span>
                    <mat-form-field class="input-detail input-due-type">
                        <input
                            type="number"
                            min="0"
                            placeholder=""
                            #description="ngModel"
                            name="dueOffset"
                            [(ngModel)]="program.dueOffset"
                            (click)="enableDueDate()"
                            matInput
                        />
                    </mat-form-field>
                    <mat-form-field class="input-detail input-due-type">
                        <mat-select name="dueType" [(ngModel)]="program.dueType" (click)="enableDueDate()">
                            <mat-option value="day">{{ 'dateTime.days' | translate }}</mat-option>
                            <mat-option value="month">{{ 'dateTime.months' | translate }}</mat-option>
                            <mat-option value="year">{{ 'dateTime.years' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <span class="label">{{ 'forms.training.afterEnrollmentDate' | translate }}</span>
                    <ui-info [text]="toolTipDueDateText"></ui-info>
                </div>
            </div>

            <div class="form-block">
                <h4>{{ 'forms.training.doesThisProgramRepeat' | translate }}</h4>
                <div class="app-grid">
                    <mat-radio-group aria-label="Select an option" name="hasRecurrence" [(ngModel)]="hasRecurrence">
                        <div>
                            <mat-radio-button [value]="false">{{
                                'training.doesNotRepeat' | translate
                            }}</mat-radio-button>
                        </div>
                        <div>
                            <mat-radio-button [value]="true">{{
                                'forms.training.doesRepeat' | translate
                            }}</mat-radio-button>
                        </div>
                    </mat-radio-group>
                </div>

                <div *ngIf="hasRecurrence">
                    <span class="label input-detail">{{ 'forms.training.repeats' | translate }}</span>
                    <mat-form-field style="width: 250px">
                        <mat-select
                            name="recurrenceType"
                            [(ngModel)]="program.recurrenceType"
                            (ngModelChange)="onRecurrenceTypeChange()"
                            placeholder="{{ 'forms.training.selectOption' | translate }}"
                        >
                            <mat-option value="annual">{{ 'forms.training.onSpecificDay' | translate }}</mat-option>
                            <mat-option value="frequency">{{
                                'forms.training.relativeToEnrollmentDate' | translate
                            }}</mat-option>
                            <mat-option value="expiration">{{
                                'forms.training.dependentOnExpirationDate' | translate
                            }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <span class="input-detail" *ngIf="program.recurrenceType === 'expiration'">
                        <ui-info [text]="toolTipExpiredRecurrenceTypeText"></ui-info>
                    </span>

                    <span class="label input-detail" *ngIf="program.recurrenceType === 'annual'"
                        >{{ 'forms.training.every' | translate }}
                        <span class="input-detail">
                            <mat-form-field style="width: 90px">
                                <mat-select
                                    name="recurrenceAnnualMonth"
                                    [(ngModel)]="program.recurrenceAnnualMonth"
                                    placeholder="{{ 'dateTime.month' | translate }}"
                                >
                                    <mat-option *ngFor="let month of months; index as i" [value]="i + 1">{{
                                        month
                                    }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </span>
                        <span class="input-detail">
                            <mat-form-field style="width: 70px">
                                <mat-select
                                    name="recurrenceAnnualDay"
                                    [(ngModel)]="program.recurrenceAnnualDay"
                                    placeholder="{{ 'dateTime.day' | translate }}"
                                >
                                    <mat-option *ngFor="let day of daysOfMonth; index as i" [value]="i + 1">{{
                                        i + 1
                                    }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </span>
                    </span>

                    <span class="label input-detail" *ngIf="program.recurrenceType === 'frequency'"
                        >{{ 'forms.training.every' | translate }}
                        <span class="input-detail">
                            <mat-form-field style="width: 70px"
                                ><input
                                    type="number"
                                    min="0"
                                    placeholder=""
                                    #description="ngModel"
                                    name="frequencyOffset"
                                    [(ngModel)]="program.frequencyOffset"
                                    matInput
                                />
                            </mat-form-field>
                        </span>

                        <span class="input-detail">
                            <mat-form-field style="width: 100px">
                                <mat-select name="frequencyType" [(ngModel)]="program.frequencyType">
                                    <mat-option value="day">{{ 'dateTime.days' | translate }}</mat-option>
                                    <mat-option value="month">{{ 'dateTime.months' | translate }}</mat-option>
                                    <mat-option value="year">{{ 'dateTime.years' | translate }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <ui-info [text]="toolTipFrequentRecurrenceTypeText"></ui-info>
                        </span>
                    </span>
                </div>

                <div *ngIf="hasRecurrence">
                    <h4>{{ 'forms.training.doesThisProgramEnd' | translate }}</h4>
                    <div class="app-grid">
                        <mat-radio-group
                            aria-label="Select an option"
                            name="hasMaxOccurrences"
                            [(ngModel)]="hasMaxOccurrences"
                        >
                            <div>
                                <mat-radio-button [value]="false">{{
                                    'forms.training.doesNotEnd' | translate
                                }}</mat-radio-button>
                            </div>
                            <div>
                                <mat-radio-button [value]="true"
                                    >{{ 'forms.training.doesEnd' | translate }}
                                </mat-radio-button>
                            </div>
                        </mat-radio-group>
                        <div *ngIf="hasMaxOccurrences">
                            <span class="label input-detail"
                                >{{ 'forms.training.endTrainingAfter' | translate }}
                                <mat-form-field style="width: 70px"
                                    ><input
                                        type="number"
                                        min="0"
                                        placeholder=""
                                        #description="ngModel"
                                        name="maxOccurrences"
                                        [(ngModel)]="program.maxOccurrences"
                                        matInput
                                    />
                                </mat-form-field>
                                <span class="label" style="padding: 5px">{{
                                    'forms.training.sessions' | translate
                                }}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <span class="input-detail"></span>

                <ng-template #noEmployeesEnrolled>
                    <div class="form-block">
                        <h4>{{ 'forms.training.noEmployeesSelectedForEnrollment' | translate }}</h4>
                    </div>
                </ng-template>
                <app-table
                    *ngIf="table && !table.isEmpty; else noEmployeesEnrolled"
                    [title]="'forms.training.employeesSelectedForEnrollment' | translate"
                    [showHeader]="false"
                    [table]="table"
                    [showSearch]="false"
                    [useStickyHeader]="false"
                    [embedded]="true"
                    [isSmall]="true"
                    (menuItemSelected)="unEnrollAction($event)"
                >
                    <div class="empty">
                        <img style="max-width: 30%" src="/assets/illustrations/sofa.png" />
                        <h2 class="ui centered header">{{ 'forms.training.noEmployeesSelected' | translate }}</h2>
                    </div>
                </app-table>

                <div class="form-block" (click)="onAssignClick()">
                    <ui-button type="primary">{{ 'forms.training.addOrRemoveEmployees' | translate }}</ui-button>
                </div>
            </div>
        </div>
    </ng-container>
</form>
